import React, { useEffect, useState } from "react";
import LabelWithInput from "@components/input/LabelWithInput";
import styled from "@emotion/styled";
import FileUploadInput from "@components/input/FileUploadInput";
import RegisterTipDrawer from "@components/drawer/RegisterTipDrawer";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import BasicModal from "@components/modal/BasicModal";
import PhotoModal from "@components/modal/PhotoModal";
import { loginSchema } from "@libs/zod/zodVaildation";
import { log } from "console";

const LabelWrapper = styled.div({
  position: "relative",
});

const TipButton = styled.button(({ theme }) => ({
  position: "absolute",
  top: "0",
  right: "0",
  fontSize: "1.2rem",
  color: theme.color.green,
  lineHeight: "1.2rem",
  fontWeight: theme.fontWeight.bold,
}));

const ImageCountWrapper = styled.div(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "0.5rem",
  fontSize: "1.2rem",
  color: theme.color.gray,

  ".count": {
    color: theme.color.orange,
  },
}));
const ErrorMessage = styled.div(({ theme }) => ({
  color: theme.color.orange,
  fontSize: "1.2rem",
}));

const ProductPhotos = () => {
  const [openTip, setOpenTip] = useState(false);
  const [modal, setModal] = useState(false);
  const {
    watch,
    trigger,
    formState: { errors },
  } = useFormContext();
  const image_list = watch("image_list");
  const { t } = useTranslation();
  const [files, setFiles] = useState(image_list || []);

  const handleOpenTip = () => {
    setOpenTip(true);
  };

  useEffect(() => {
    if (image_list) {
      trigger("image_list");
    }
  }, [image_list, trigger]);

  const notiOnClick = () => {
    setModal(true);
  };

  return (
    <div>
      <LabelWrapper>
        <LabelWithInput
          label="상품사진"
          required
          notice
          notiOnClick={notiOnClick}
          warning>
          {errors.image_list && errors.image_list.message && (
            <ErrorMessage>
              {typeof errors.image_list.message === "string"
                ? t(errors.image_list.message)
                : t("")}
            </ErrorMessage>
          )}

          <ImageCountWrapper>
            <span>{t("상품 사진 TIP을 꼭 참고해주세요")}</span>
            <span className="count">{image_list?.length}/10</span>
          </ImageCountWrapper>

          <FileUploadInput files={files} setFiles={setFiles} />
        </LabelWithInput>

        <TipButton onClick={handleOpenTip} type="button">
          {t("상품등록 TIP")}
        </TipButton>
      </LabelWrapper>
      <PhotoModal open={modal} setOpen={setModal} />

      <RegisterTipDrawer open={openTip} setOpen={setOpenTip} />
    </div>
  );
};

export default ProductPhotos;
